import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function DealJuniorDebtField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (values) => {
    setValue(values.floatValue);
  };
  return (
    <Box>
      <FormControl fullWidth>
        <NumericFormat
          value={value}
          prefix='$'
          onValueChange={handleChange}
          customInput={TextField}
          aria-describedby='junior-debt-helper-text'
          label='Junior Debt'
          id='junior_debt'
          error={Boolean(error)}
          variant='standard'
          thousandSeparator=','
          sx={{ input: { textAlign: 'right' } }}
        />

        {error ? (
          <FormHelperText id='junior-debt-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='junior-debt-helper-text'>
            Enter the total amount of all junior/mezzanine debt.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
